import React from "react";

interface ClinicalInterpretationsProps {
  interpretations: string[];
}

const ClinicalInterpretations: React.FC<ClinicalInterpretationsProps> = ({ interpretations }) => {
  if (!interpretations || interpretations.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      <h3 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">Interpretaciones Clínicas</h3>
      <div className="rounded-lg bg-gray-50 p-4">
        <ul className="list-inside list-disc space-y-3 text-gray-700 dark:text-gray-400">
          {interpretations.map((interpretation, index) => (
            <li key={index}>{interpretation}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ClinicalInterpretations; 